var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLate(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Frame",
    clipPath: "url(#clip0_1283_15984)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "time_fill"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M7.99967 1.33203C11.6817 1.33203 14.6663 4.3167 14.6663 7.9987C14.6663 11.6807 11.6817 14.6654 7.99967 14.6654C4.31767 14.6654 1.33301 11.6807 1.33301 7.9987C1.33301 4.3167 4.31767 1.33203 7.99967 1.33203ZM7.99967 3.9987C7.82286 3.9987 7.65329 4.06894 7.52827 4.19396C7.40325 4.31898 7.33301 4.48855 7.33301 4.66536V7.9987C7.33305 8.17549 7.40331 8.34504 7.52834 8.47003L9.52834 10.47C9.65408 10.5915 9.82248 10.6587 9.99727 10.6571C10.1721 10.6556 10.3393 10.5855 10.4629 10.4619C10.5865 10.3383 10.6566 10.1711 10.6581 9.9963C10.6596 9.8215 10.5924 9.6531 10.471 9.52736L8.66634 7.7227V4.66536C8.66634 4.48855 8.5961 4.31898 8.47108 4.19396C8.34605 4.06894 8.17649 3.9987 7.99967 3.9987Z",
    fill: "#FFA7A1"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1283_15984"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLate);
export default __webpack_public_path__ + "static/media/late.2a37a3695717af2caca57d8a8d340cd8.svg";
export { ForwardRef as ReactComponent };